export default __webpack_public_path__ + "static/media/business.c0d43c54.jpg";